import type BABYLON from 'babylonjs';
import type MATERIALS from 'babylonjs-materials';

import type { Color } from './color';
import { toColor3Option } from './color';
import type { Globals } from './globals';
import { compactOptions } from './options';

// TODO: Support infinite grid

// cf. https://doc.babylonjs.com/toolsAndResources/assetLibraries/materialsLibrary/gridMat

export interface GridOptions
  extends Pick<
      NonNullable<Parameters<typeof BABYLON.MeshBuilder.CreateGround>[1]>,
      'width' | 'height' | 'subdivisions'
    >,
    Partial<
      Pick<
        MATERIALS.GridMaterial,
        | 'majorUnitFrequency'
        | 'minorUnitVisibility'
        | 'gridRatio'
        | 'backFaceCulling'
        | 'opacity'
        | 'zOffset'
      >
    > {
  mainColor?: Color;
  lineColor?: Color;
}

export function createGrid(
  globals: Globals,
  scene: BABYLON.Scene,
  { width, height, subdivisions, mainColor, lineColor, ...options }: GridOptions = {}
): BABYLON.GroundMesh {
  // cf. https://github.com/BabylonJS/Babylon.js/blob/5.48.1/packages/dev/inspector/src/components/actionTabs/tabs/propertyGrids/renderGridPropertyGridComponent.tsx#L40-L77
  const gridMesh = globals.BABYLON.MeshBuilder.CreateGround(
    'gridMesh',
    { width, height, subdivisions },
    scene
  );
  gridMesh.scaling.x = 1;
  gridMesh.scaling.z = gridMesh.scaling.x;
  gridMesh.isPickable = false;

  const groundMaterial = new globals.MATERIALS.GridMaterial('gridMaterial', scene);
  Object.assign(
    groundMaterial,
    compactOptions({
      ...options,
      mainColor: toColor3Option(globals, mainColor),
      lineColor: toColor3Option(globals, lineColor),
    })
  );
  gridMesh.material = groundMaterial;
  return gridMesh;
}

export function removeGrid(globals: Globals, scene: BABYLON.Scene): void {
  scene.meshes.find((mesh) => mesh instanceof globals.BABYLON.GroundMesh)?.dispose(false, true);
}
